import React from "react";
import "./style.less";

type CircleProps = {
  color: string;
  size: number;
};

const Circle = (props: CircleProps) => (
  <span
    className="wsc_circle"
    style={{ backgroundColor: props.color, borderRadius: "50%", height: props.size, width: props.size }}
  ></span>
);

export default Circle;
